module.exports = __webpack_public_path__ + "media/images/ic_location-62d233ac232634923f73400df06bcd23.svg";